module.exports = __webpack_public_path__ + "static/story3-title-380x245-57801779fd624351644a5e447e1539a3.svg";